<template>
  <div v-if="visible" class="official-news-modal" role="dialog" aria-modal="true" aria-label="官方内幕爆料" @click.self="close">
    <div class="official-news-modal__box">
      <div class="official-news-modal__title">{{ title }}</div>
      <div class="official-news-modal__body">
        <div v-if="loading" class="official-news-modal__empty">加载中...</div>
        <template v-else-if="latestItems.length">
          <div v-for="(grp, gi) in gameGroups" :key="gi" class="official-news-modal__group">
            <div class="official-news-modal__group-head">
              <span class="official-news-modal__period">{{ itemPeriod(grp) }}期</span>
              <span class="official-news-modal__game">{{ grp.gameName }}</span>
            </div>
            <div v-for="(it, i) in grp.items" :key="i" class="official-news-modal__item">
              <div class="official-news-modal__item-row">
                <div class="official-news-modal__item-label">【{{ it.labelText }}】</div>
                <button type="button" class="official-news-modal__copy" @click="copyItem(it, i)">
                  {{ copiedIndex === i ? '已复制' : '复制' }}
                </button>
              </div>
              <div class="official-news-modal__content">{{ it.contentText }}</div>
            </div>
          </div>
        </template>
        <div v-else class="official-news-modal__empty">暂无内容</div>
      </div>
      <button type="button" class="official-news-modal__btn" @click="close">关闭</button>
    </div>
  </div>
</template>

<script>
import { fetchPredictionSections, fetchPredictionItems } from '@/api/prediction'
import { fetchLotteryTypesList } from '@/api/lotteryTypes'

export default {
  name: 'OfficialNewsModal',
  props:{
    title:{String,default:'官方公告'},
  },
  data() {
    return {
      visible: true,
      loading: false,
      latestItems: [],
      copiedIndex: null
    }
  },
  computed: {
    site() {
      return process.env.VUE_APP_SITE_ID || 'default'
    },
    gameGroups() {
      const groups = []
      const map = new Map()
      this.latestItems.forEach(it => {
        const key = it.gameName || '其他'
        if (!map.has(key)) {
          const g = { gameName: key, period: '', items: [] }
          map.set(key, g)
          groups.push(g)
        }
        const g = map.get(key)
        g.items.push(it)
        if ((Number(it.period) || 0) > (Number(g.period) || 0)) g.period = it.period
      })
      return groups
    }
  },
  watch: {
    visible(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    }
  },
  mounted() {
    this.loadData()
    this._onKeydown = e => { if (e.key === 'Escape' && this.visible) this.close() }
    document.addEventListener('keydown', this._onKeydown)
  },
  beforeDestroy() {
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this._onKeydown)
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const [sectionsRes, typesRes] = await Promise.all([
          fetchPredictionSections({ site: this.site, zoneType: 4 }),
          fetchLotteryTypesList({ site: this.site })
        ])
        const data = sectionsRes.data
        const sections =
          data && data.code === 200 && data.data && Array.isArray(data.data.sections)
            ? data.data.sections
            : []
        const td = typesRes.data
        const games =
          td && td.code === 200 && td.data && Array.isArray(td.data.list) ? td.data.list : []
        if (!sections.length) {
          this.latestItems = []
          this.loading = false
          return
        }
        const queries = []
        sections.forEach(s => {
          games.forEach(g => {
            queries.push(
              fetchPredictionItems({ site: this.site, sectionId: s.id, game: g.code })
                .then(r => {
                  const d = r.data
                  const items =
                    d && d.code === 200 && d.data && Array.isArray(d.data.items) ? d.data.items : []
                  const latest =
                    items
                      .slice()
                      .sort((a, b) => (Number(b && b.period) || 0) - (Number(a && a.period) || 0))[0] ||
                    null
                  return latest ? Object.assign({}, latest, { gameName: g.nameCn }) : null
                })
                .catch(() => null)
            )
          })
        })
        const results = await Promise.all(queries)
        this.latestItems = results.filter(Boolean)
      } catch (e) {
        this.latestItems = []
      }
      this.loading = false
    },
    itemPeriod(it) {
      const p = it && it.period
      return p == null ? '' : String(p).slice(-3)
    },
    copyItem(it, i) {
      const text = it && it.contentText != null ? String(it.contentText) : ''
      if (!text) return
      const done = () => {
        this.copiedIndex = i
        setTimeout(() => { this.copiedIndex = null }, 1500)
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done))
      } else {
        this.fallbackCopy(text, done)
      }
    },
    fallbackCopy(text, done) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        done()
      } catch (e) {
        /* ignore */
      }
      document.body.removeChild(ta)
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.official-news-modal {
  position: fixed;
  inset: 0;
  z-index: 110;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 4vw, 1.25rem);
  padding-top: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-top));
  padding-bottom: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-bottom));
  background: rgba(0, 0, 0, 0.88);
  box-sizing: border-box;
}
.official-news-modal__box {
  width: 100%;
  max-height: min(80vh, calc(100vh - 6rem));
  overflow-y: auto;
  background: #fff;
  border-radius: clamp(0.25rem, 1.5vw, 0.5rem);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.official-news-modal__title {
  flex: 0 0 auto;
  background: linear-gradient(90deg, #d32f2f, #e53935);
  color: #ffd54f;
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  padding: 0.6rem;
  letter-spacing: 0.08em;
}
.official-news-modal__body {
  flex: 1;
  min-height: 0;
  padding: 0.75rem;
  color: #1a1a1a;
  font-size: 0.95rem;
  line-height: 1.6;
  word-break: break-word;
}
.official-news-modal__group {
  text-align: center;
}
.official-news-modal__item + .official-news-modal__item {
  margin-top: 0.3rem;
}
.official-news-modal__group + .official-news-modal__group {
  margin-top: 0.5rem;
  border-top: 1px dashed #e2e8f0;
  padding-top: 0.4rem;
}
.official-news-modal__group-head {
  font-weight: 700;
  color: #c00;
  font-size: 1rem;
  margin-bottom: 0.2rem;
}
.official-news-modal__game {
  margin-left: 0.3rem;
}
.official-news-modal__period {
  font-weight: 700;
  margin-right: 0.3rem;
}
.official-news-modal__item-label {
  font-weight: 700;
  color: #c00;
}
.official-news-modal__item-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}
.official-news-modal__content {
  word-break: break-word;
  font-weight: 700;
}
.official-news-modal__copy {
  flex: 0 0 auto;
  border: none;
  border-radius: 999px;
  background: #1e6bd6;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.15rem 0.6rem;
  cursor: pointer;
}
.official-news-modal__copy:active {
  background: #1552a8;
}
.official-news-modal__empty {
  color: #718096;
  text-align: center;
  padding: 0.5rem 0;
}
.official-news-modal__btn {
  position: sticky;
  bottom: 0;
  flex: 0 0 auto;
  margin-top: auto;
  display: block;
  width: 100%;
  border: none;
  border-top: 1px solid #e2e8f0;
  background: #1e6bd6;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  padding: 0.7rem 0;
  cursor: pointer;
}
</style>
